<template>
  <div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity"></div>
    <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div class="flex min-h-full items-center justify-center p-4">
        <div class="relative transform overflow-hidden rounded-lg bg-gray-800 text-white shadow-xl transition-all sm:max-w-3xl w-full">
          <div class="p-6">
            <!-- หัวข้อและปุ่มปิด -->
            <div class="flex justify-between items-center mb-6">
              <h3 class="text-xl font-semibold text-indigo-300">แก้ไขไอเทม: {{ editedItem.name }}</h3>
              <button @click="$emit('cancelModal')" class="text-gray-400 hover:text-white">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <!-- ฟอร์ม -->
            <form @submit.prevent="handleUpdateItem">
              <!-- Tab Navigation -->
              <div class="flex border-b border-gray-600 mb-6">
                <button
                  type="button"
                  :class="['px-4 py-2 text-sm font-medium', activeTab === 1 ? 'border-b-2 border-indigo-500 text-indigo-300' : 'text-gray-400 hover:text-white']"
                  @click="activeTab = 1"
                >
                  ข้อมูลพื้นฐาน
                </button>
                <button
                  type="button"
                  :class="['px-4 py-2 text-sm font-medium', activeTab === 2 ? 'border-b-2 border-indigo-500 text-indigo-300' : 'text-gray-400 hover:text-white']"
                  @click="activeTab = 2"
                >
                  การแยกชิ้นส่วนและอัพเกรด
                </button>
              </div>
              <!-- Tab Content -->
              <div v-show="activeTab === 1" class="h-96 overflow-auto">
                <!-- ข้อมูลพื้นฐาน -->
                <div class="space-y-4 mb-6">
                  <h4 class="text-lg font-medium text-gray-300">ข้อมูลพื้นฐาน</h4>
                  <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">ชื่อไอเทม</label>
                      <input
                        v-model="editedItem.name"
                        type="text"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">ลิงค์รูปภาพ</label>
                      <input
                        v-model="editedItem.img"
                        type="url"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        placeholder="https://example.com/image.jpg"
                        required
                      >
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">ประเภทไอเทม</label>
                      <select
                        v-model="editedItem.type"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                        <option value="หมวก">หมวก</option>
                        <option value="แว่นตา">แว่นตา</option>
                        <option value="เสื้อ">เสื้อ</option>
                        <option value="เสื้อคลุม">เสื้อคลุม</option>
                        <option value="เกราะ">เกราะ</option>
                        <option value="ปลอกแขน">ปลอกแขน</option>
                        <option value="ถุงมือ">ถุงมือ</option>
                        <option value="กางเกง">กางเกง</option>
                        <option value="สนับแข้ง">สนับแข้ง</option>
                        <option value="รองเท้า">รองเท้า</option>
                        <option value="เข็มขัด">เข็มขัด</option>
                        <option value="สร้อยคอ">สร้อยคอ</option>
                        <option value="แหวน">แหวน</option>
                        <option value="อาวุธ">อาวุธ</option>
                        <option value="อาวุธสำรอง">อาวุธสำรอง</option>
                        <option value="ตะกรุด">ตะกรุด</option>
                        <option value="ผ้ายันต์">ผ้ายันต์</option>
                        <option value="สายสิญจน์">สายสิญจน์</option>
                        <option value="หนังสือ">หนังสือ</option>
                        <option value="อาหาร">อาหาร</option>
                        <option value="แผนที่">แผนที่</option>
                        <option value="รักษา">รักษา</option>
                        <option value="กัปดัก">กัปดัก</option>
                        <option value="ระเบิด">ระเบิด</option>
                        <option value="ปลดกัปดัก">ปลดกัปดัก</option>
                        <option value="พาหนะ">พาหนะ</option>
                        <option value="วัสดุ">วัสดุ</option>
                        <option value="วัสดุวิญญาณ">วัสดุวิญญาณ</option>
                        <option value="วัสดุสิ่งมีชีวิตกลายพันธุ์">วัสดุสิ่งมีชีวิตกลายพันธุ์</option>
                        <option value="ทั่วไป">ทั่วไป</option>
                        <option value="กล่อง">กล่อง</option>
                        <option value="หุ่นยนต์สังหาร">หุ่นยนต์สังหาร</option>
                        <option value="อวัยวะจักรกล">อวัยวะจักรกล</option>
                        <option value="ปล้น">ปล้น</option>
                        <option value="การ์ด">การ์ด</option>
                        <option value="วิญญาณ">วิญญาณ</option>
                        <option value="สิ่งมีชีวิตกลายพันธุ์">สิ่งมีชีวิตกลายพันธุ์</option>
                        <option value="ไล่ผี">ไล่ผี</option>
                      </select>
                    </div>
                    <div v-if="editedItem.type === 'วิญญาณ'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">ประเภทย่อย</label>
                      <select
                        v-model="editedItem.subtype"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                        <option value="วิญญาณเฝ้าห้อง">วิญญาณเฝ้าห้อง</option>
                        <option value="วิญญาณค้นหาผู้เล่น">วิญญาณค้นหาผู้เล่น</option>
                        <option value="วิญญาณผู้พิทักษ์">วิญญาณผู้พิทักษ์</option>
                        <option value="วิญญาณดูดทรัพย์">วิญญาณดูดทรัพย์</option>
                      </select>
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">เลเวลที่สามารถใส่ได้</label>
                      <input
                        v-model.number="editedItem.requiredLevel"
                        type="number"
                        min="1"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">น้ำหนัก (กก.)</label>
                      <input
                        v-model.number="editedItem.weight"
                        type="number"
                        min="0"
                        step="0.1"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">สามารถสวมใส่ได้?</label>
                      <select
                        v-model="editedItem.wearable"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                        :disabled="editedItem.type === 'ปล้น'"
                      >
                        <option :value="true">ใช่</option>
                        <option :value="false">ไม่</option>
                      </select>
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">สามารถโอนให้ผู้เล่นคนอื่นได้?</label>
                      <select
                        v-model="editedItem.transfer"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                        <option :value="true">ใช่</option>
                        <option :value="false">ไม่</option>
                      </select>
                    </div>
                    <!-- Additional inputs for food type -->
                    <div v-if="editedItem.type === 'อาหาร'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">ระดับอาหาร</label>
                      <input
                        v-model.number="editedItem.foodLevel"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="editedItem.type === 'อาหาร'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">ระดับความสุข</label>
                      <input
                        v-model.number="editedItem.happinessLevel"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="editedItem.type === 'อาหาร'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">ระดับพลังงาน</label>
                      <input
                        v-model.number="editedItem.energyLevel"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <!-- Additional inputs for healing type -->
                    <div v-if="editedItem.type === 'รักษา'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">HP ที่ได้รับเมื่อรักษา (%)</label>
                      <input
                        v-model.number="editedItem.healHpPercentage"
                        type="number"
                        min="0"
                        max="100"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="editedItem.type === 'รักษา'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">การรักษาติดเชื้อไวรัส (%)</label>
                      <input
                        v-model.number="editedItem.virusHealPercentage"
                        type="number"
                        min="0"
                        max="100"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <!-- Additional inputs for trap type -->
                    <div v-if="editedItem.type === 'กัปดัก'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนลูกเต๋า</label>
                      <input
                        v-model.number="editedItem.diceCount"
                        type="number"
                        min="1"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="editedItem.type === 'กัปดัก'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">สร้างความเสียหาย</label>
                      <input
                        v-model.number="editedItem.damage"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="editedItem.type === 'กัปดัก'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">ระยะเวลาชั่วโมง</label>
                      <input
                        v-model.number="editedItem.durationHours"
                        type="number"
                        min="0"
                        step="0.1"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="editedItem.type === 'กัปดัก'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนครั้งที่ใช้งานได้</label>
                      <input
                        v-model.number="editedItem.useCount"
                        type="number"
                        min="1"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <!-- Additional inputs for bomb type -->
                    <div v-if="editedItem.type === 'ระเบิด'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">ความเสียหายที่จะได้รับ</label>
                      <input
                        v-model.number="editedItem.damage"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <!-- Additional input for vehicle type -->
                    <div v-if="editedItem.type === 'พาหนะ'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">ระดับน้ำมัน</label>
                      <input
                        v-model.number="editedItem.fuelLevel"
                        type="number"
                        min="1"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <!-- Additional input for book type -->
                    <div v-if="editedItem.type === 'หนังสือ'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">ลำดับ</label>
                      <input
                        v-model.number="editedItem.order"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <!-- Additional inputs for disarm trap type -->
                    <div v-if="editedItem.type === 'ปลดกัปดัก'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนห้องที่สามารถปลดกัปดักได้</label>
                      <input
                        v-model.number="editedItem.disarmRoomCount"
                        type="number"
                        min="1"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <!-- Additional inputs for killer robot type -->
                    <div v-if="editedItem.type === 'หุ่นยนต์สังหาร'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">น้ำหนักที่หุ่นยนต์สามารถรับได้ (กก.)</label>
                      <input
                        v-model.number="editedItem.maxLoad"
                        type="number"
                        min="0"
                        step="0.1"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <!-- Additional inputs for loot type -->
                    <div v-if="editedItem.type === 'ปล้น'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">ระยะเวลาที่ต้องรอ (นาที)</label>
                      <input
                        v-model.number="editedItem.waitTimeMinutes"
                        type="number"
                        min="0"
                        step="1"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="editedItem.type === 'ปล้น'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนไอเทมที่ปล้นได้ขั้นต่ำ</label>
                      <input
                        v-model.number="editedItem.minLootItems"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="editedItem.type === 'ปล้น'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนไอเทมที่ปล้นได้ขั้นสูงสุด</label>
                      <input
                        v-model.number="editedItem.maxLootItems"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="editedItem.type === 'ปล้น'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนเหรียญที่ได้รับหลังชนะ</label>
                      <input
                        v-model.number="editedItem.silverReward"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="editedItem.type === 'ปล้น'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนทองที่ได้รับหลังชนะ</label>
                      <input
                        v-model.number="editedItem.goldReward"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="editedItem.type === 'ปล้น'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนเพชรที่ได้รับหลังชนะ</label>
                      <input
                        v-model.number="editedItem.diamondReward"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <!-- Additional inputs for card type -->
                    <div v-if="editedItem.type === 'การ์ด'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">ชื่ออวัยวะจักรกลที่สามารถติดตั้งการ์ดได้</label>
                      <select
                        v-model="editedItem.compatibleEquipment"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                        <option value="" disabled>เลือกอวัยวะจักรกล</option>
                        <option value="ขาจักรกล">ขาจักรกล</option>
                        <option value="ซี่โครงจักรกล">ซี่โครงจักรกล</option>
                        <option value="ดวงตาจักรกล">ดวงตาจักรกล</option>
                        <option value="สมองจักรกล">สมองจักรกล</option>
                        <option value="หมัดจักรกล">หมัดจักรกล</option>
                        <option value="หัวใจจักรกล">หัวใจจักรกล</option>
                        <option value="แขนจักรกล">แขนจักรกล</option>
                        <option value="ลำตัวจักรกล">ลำตัวจักรกล</option>
                        <option value="สะโพกจักรกล">สะโพกจักรกล</option>
                        <option value="ตาหลังจักรกล">ตาหลังจักรกล</option>
                        <option value="กรามจักรกล">กรามจักรกล</option>
                        <option value="ไหล่จักรกล">ไหล่จักรกล</option>
                        <option value="จมูกจักรกล">จมูกจักรกล</option>
                        <option value="หูจักรกล">หูจักรกล</option>
                        <option value="ปีกจักรกล">ปีกจักรกล</option>
                        <option value="หนวดจักรกล">หนวดจักรกล</option>
                        <option value="เขาจักรกล">เขาจักรกล</option>
                      </select>
                    </div>
                    <!-- Additional inputs for spirit subtypes -->
                    <div v-if="editedItem.type === 'วิญญาณ' && editedItem.subtype === 'วิญญาณเฝ้าห้อง'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">ระยะเวลาที่เฝ้า (ชั่วโมง)</label>
                      <input
                        v-model.number="editedItem.guardDurationHours"
                        type="number"
                        min="0"
                        step="0.1"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="editedItem.type === 'วิญญาณ' && editedItem.subtype === 'วิญญาณเฝ้าห้อง'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">วิญญาณจากแผนที่</label>
                      <input
                        v-model="editedItem.fromMap"
                        type="text"
                        placeholder="ชื่อแผนที่ (ใส่ได้แผนที่เดียว)"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="editedItem.type === 'วิญญาณ' && editedItem.subtype === 'วิญญาณเฝ้าห้อง'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนวิญญาณขั้นต่ำ</label>
                      <input
                        v-model.number="editedItem.minSpirits"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="editedItem.type === 'วิญญาณ' && editedItem.subtype === 'วิญญาณเฝ้าห้อง'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนวิญญาณสูงสุด</label>
                      <input
                        v-model.number="editedItem.maxSpirits"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="editedItem.type === 'วิญญาณ' && editedItem.subtype === 'วิญญาณค้นหาผู้เล่น'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนห้องที่ถูกคัดออก</label>
                      <input
                        v-model.number="editedItem.eliminatedRooms"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="editedItem.type === 'วิญญาณ' && editedItem.subtype === 'วิญญาณผู้พิทักษ์'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนเกราะที่สามารถป้องกันได้</label>
                      <input
                        v-model.number="editedItem.protectCount"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="editedItem.type === 'วิญญาณ' && editedItem.subtype === 'วิญญาณผู้พิทักษ์'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">ระยะเวลาคุ้มกัน (ชั่วโมง)</label>
                      <input
                        v-model.number="editedItem.protectDurationHours"
                        type="number"
                        min="0"
                        step="0.1"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="editedItem.type === 'วิญญาณ' && editedItem.subtype === 'วิญญาณดูดทรัพย์'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนปล้นเพชรขั้นต่ำ</label>
                      <input
                        v-model.number="editedItem.minDiamondLoot"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="editedItem.type === 'วิญญาณ' && editedItem.subtype === 'วิญญาณดูดทรัพย์'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนปล้นเพชรขั้นสูงสุด</label>
                      <input
                        v-model.number="editedItem.maxDiamondLoot"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <!-- Cooldown input for specific spirit subtypes -->
                    <div v-if="editedItem.type === 'วิญญาณ' && ['วิญญาณเฝ้าห้อง', 'วิญญาณผู้พิทักษ์', 'วิญญาณดูดทรัพย์'].includes(editedItem.subtype)">
                      <label class="block text-sm font-medium mb-1 text-gray-300">ระยะเวลาคูดาวน์การใช้ครั้งถัดไป (ชั่วโมง)</label>
                      <input
                        v-model.number="editedItem.cooldownHours"
                        type="number"
                        min="0"
                        step="0.1"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <!-- Required previous spirits for spirit type -->
                    <div v-if="editedItem.type === 'วิญญาณ'" class="mt-4 space-y-3">
                      <label class="block text-sm font-medium mb-1 text-gray-300">วิญญาณที่ต้องเคยอัญเชิญมาก่อน</label>
                      <div v-for="(spirit, index) in editedItem.requiredPreviousSpirits" :key="index" class="grid grid-cols-12 items-center gap-3 animate-fade-in">
                        <div class="col-span-10 sm:col-span-10">
                          <input
                            v-model="editedItem.requiredPreviousSpirits[index]"
                            type="text"
                            placeholder="ชื่อวิญญาณ"
                            class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                          >
                        </div>
                        <div class="col-span-2">
                          <button
                            v-if="index > 0"
                            @click="removeRequiredPreviousSpirit(index)"
                            type="button"
                            class="w-full px-2 py-1.5 bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 text-white transition duration-200"
                            aria-label="ลบวิญญาณ"
                          >
                            ลบ
                          </button>
                        </div>
                      </div>
                      <div class="flex gap-3 mt-3">
                        <button
                          @click="addRequiredPreviousSpirit"
                          type="button"
                          class="px-4 py-2 bg-green-600 rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 text-white transition duration-200"
                        >
                          + เพิ่มวิญญาณ
                        </button>
                      </div>
                    </div>
                    <!-- Explorable maps for killer robot type -->
                    <div v-if="editedItem.type === 'หุ่นยนต์สังหาร'" class="mt-4">
                      <label class="block text-sm font-medium mb-1 text-gray-300">สถานที่ที่สามารถส่งหุ่นยนต์ไปได้</label>
                      <div class="space-y-2">
                        <div v-for="(location, index) in editedItem.explorableMaps" :key="index" class="grid grid-cols-12 items-center gap-3 animate-fade-in">
                          <div class="col-span-10">
                            <input
                              v-model="editedItem.explorableMaps[index]"
                              type="text"
                              placeholder="ชื่อสถานที่"
                              class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                            >
                          </div>
                          <div class="col-span-2">
                            <button
                              v-if="index > 0"
                              @click="removeExplorableMap(index)"
                              type="button"
                              class="w-full px-2 py-1.5 bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 text-white transition duration-200"
                              aria-label="ลบสถานที่"
                            >
                              ลบ
                            </button>
                          </div>
                        </div>
                        <div class="flex gap-3 mt-3">
                          <button
                            @click="addExplorableMap"
                            type="button"
                            class="px-4 py-2 bg-green-600 rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 text-white transition duration-200"
                          >
                            + เพิ่มสถานที่
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- คุณสมบัติ -->
                  <div class="space-y-4 mb-6">
                    <h4 class="text-lg font-medium text-gray-300">คุณสมบัติ</h4>
                    <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">ระดับดาว</label>
                        <select
                          v-model.number="editedItem.rarity"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                          required
                        >
                          <option value="" disabled>เลือกระดับดาว</option>
                          <option value="0">0 ดาว</option>
                          <option value="1">1 ดาว</option>
                          <option value="2">2 ดาว</option>
                          <option value="3">3 ดาว</option>
                          <option value="4">4 ดาว</option>
                          <option value="5">5 ดาว</option>
                          <option value="6">6 ดาว</option>
                          <option value="7">7 ดาว</option>
                          <option value="8">8 ดาว</option>
                          <option value="9">9 ดาว</option>
                          <option value="10">10 ดาว</option>
                          <option value="11">11 ดาว</option>
                          <option value="12">12 ดาว</option>
                          <option value="13">13 ดาว</option>
                          <option value="14">14 ดาว</option>
                          <option value="15">15 ดาว</option>
                          <option value="16">16 ดาว</option>
                          <option value="17">17 ดาว</option>
                          <option value="18">18 ดาว</option>
                          <option value="19">19 ดาว</option>
                          <option value="20">20 ดาว</option>
                        </select>
                      </div>
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">ราคา</label>
                        <input
                          v-model.number="editedItem.price"
                          type="number"
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                          required
                        >
                      </div>
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">ประเภทหน่วยเงิน</label>
                        <select
                          v-model="editedItem.currencyType"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                          required
                        >
                          <option value="silver">Silver</option>
                          <option value="gold">Gold</option>
                          <option value="diamond">Diamond</option>
                        </select>
                      </div>
                      <div class="sm:col-span-3">
                        <label class="block text-sm font-medium mb-1 text-gray-300">คำอธิบาย</label>
                        <textarea
                          v-model="editedItem.description"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                          rows="2"
                          placeholder="อธิบายคุณสมบัติหรือเรื่องราวของไอเทม"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <!-- ค่าสถานะ -->
                  <div v-if="editedItem.type !== 'ปลดกัปดัก' && editedItem.type !== 'ปล้น'" class="space-y-4 mb-6">
                    <h4 class="text-lg font-medium text-gray-300">ค่าสถานะ</h4>
                    <div class="grid grid-cols-2 sm:grid-cols-5 gap-4">
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">Stamina</label>
                        <input
                          v-model.number="editedItem.stats.stamina"
                          type="number"
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">Strength</label>
                        <input
                          v-model.number="editedItem.stats.str"
                          type="number"
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">Intelligence</label>
                        <input
                          v-model.number="editedItem.stats.int"
                          type="number"
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">Agility</label>
                        <input
                          v-model.number="editedItem.stats.agi"
                          type="number"
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">Luck</label>
                        <input
                          v-model.number="editedItem.stats.luck"
                          type="number"
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">Max HP</label>
                        <input
                          v-model.number="editedItem.stats.maxHp"
                          type="number"
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">Attack</label>
                        <input
                          v-model.number="editedItem.stats.atk"
                          type="number"
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">Evasion</label>
                        <input
                          v-model.number="editedItem.stats.evasion"
                          type="number"
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">Critical</label>
                        <input
                          v-model.number="editedItem.stats.critical"
                          type="number"
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">Defense</label>
                        <input
                          v-model.number="editedItem.stats.defense"
                          type="number"
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="activeTab === 2">
                <!-- การแยกชิ้นส่วนและอัพเกรด -->
                <div class="space-y-4 mb-6 max-h-96 overflow-auto" id="style-1">
                  <h4 class="text-lg font-medium text-gray-300">การแยกชิ้นส่วนและอัพเกรด</h4>
                  <div class="grid grid-cols-1 gap-4">
                    <!-- ส่วนแยกชิ้นส่วน -->
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">สามารถแยกชิ้นส่วนได้?</label>
                      <select
                        v-model="editedItem.decomposable"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                        <option :value="true">ใช่</option>
                        <option :value="false">ไม่</option>
                      </select>
                      <div v-if="editedItem.decomposable" class="mt-2 space-y-3 h-40 overflow-auto" id="style-1">
                        <div v-for="(decompose, index) in editedItem.decomposeList" :key="index" class="grid grid-cols-12 items-center gap-3 animate-fade-in">
                          <div class="col-span-6 sm:col-span-7">
                            <input
                              v-model="decompose.itemName"
                              type="text"
                              placeholder="ชื่อไอเทมที่ได้"
                              class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                            >
                          </div>
                          <div class="col-span-4 sm:col-span-3">
                            <input
                              v-model.number="decompose.chance"
                              type="number"
                              min="0"
                              max="100"
                              placeholder="โอกาส (%)"
                              class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                            >
                          </div>
                          <div class="col-span-2">
                            <button
                              v-if="index > 0"
                              @click="removeDecompose(index)"
                              type="button"
                              class="w-full px-2 py-1.5 bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 text-white transition duration-200"
                              aria-label="ลบไอเทม"
                            >
                              ลบ
                            </button>
                          </div>
                        </div>
                        <div class="flex gap-3 mt-3">
                          <button
                            @click="addDecompose"
                            type="button"
                            class="px-4 py-2 bg-green-600 rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 text-white transition duration-200"
                          >
                            + เพิ่มไอเทม
                          </button>
                        </div>
                        <div v-if="totalDecomposeChance > 0" class="text-sm text-gray-400 mt-2">
                          <p>โอกาสการแยกชิ้นส่วน (รวม: {{ totalDecomposeChance.toFixed(2) }}%):</p>
                          <ul class="list-disc list-inside">
                            <li v-for="(decompose, index) in editedItem.decomposeList" :key="index">
                              {{ decompose.itemName || 'ยังไม่ระบุ' }}: {{ decompose.chance || 0 }}%
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <!-- ส่วนอัพเกรด -->
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">สามารถอัพเกรดได้?</label>
                      <select
                        v-model="editedItem.upgradable"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                        <option :value="true">ใช่</option>
                        <option :value="false">ไม่</option>
                      </select>
                      <div v-if="editedItem.upgradable" class="mt-2 space-y-2">
                        <input
                          v-model="editedItem.upgradeTo"
                          type="text"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                          placeholder="ชื่อไอเทมถัดไป"
                        >
                        <input
                          v-model.number="editedItem.upgradeChance"
                          type="number"
                          min="0"
                          max="100"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                          placeholder="โอกาสสำเร็จ (%)"
                        >
                      </div>
                    </div>
                    <!-- Additional section for killer robot type -->
                    <div v-if="editedItem.type === 'หุ่นยนต์สังหาร'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนครั้งที่อัปเกรดได้</label>
                      <input
                        v-model.number="editedItem.maxUpgradeCount"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                      <div class="mt-4">
                        <label class="block text-sm font-medium mb-1 text-gray-300">ไอเทมที่ใช้ในการอัปเกรด</label>
                        <div v-for="(material, index) in editedItem.upgradeMaterials" :key="index" class="grid grid-cols-12 items-center gap-3 animate-fade-in">
                          <div class="col-span-6 sm:col-span-7">
                            <input
                              v-model="material.itemName"
                              type="text"
                              placeholder="ชื่อไอเทม"
                              class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                            >
                          </div>
                          <div class="col-span-4 sm:col-span-3">
                            <input
                              v-model.number="material.quantity"
                              type="number"
                              min="0"
                              placeholder="จำนวน"
                              class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                            >
                          </div>
                          <div class="col-span-2">
                            <button
                              v-if="index > 0"
                              @click="removeUpgradeMaterial(index)"
                              type="button"
                              class="w-full px-2 py-1.5 bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 text-white transition duration-200"
                              aria-label="ลบไอเทม"
                            >
                              ลบ
                            </button>
                          </div>
                        </div>
                        <div class="flex gap-3 mt-3">
                          <button
                            @click="addUpgradeMaterial"
                            type="button"
                            class="px-4 py-2 bg-green-600 rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 text-white transition duration-200"
                          >
                            + เพิ่มไอเทม
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Additional section for cybernetic organ type -->
                    <div v-if="editedItem.type === 'อวัยวะจักรกล'">
                      <div class="mt-4 space-y-3">
                        <label class="block text-sm font-medium mb-1 text-gray-300">ค่าสถานะที่สามารถอัปเกรดได้</label>
                        <select
                          v-model="editedItem.upgradeableStats"
                          multiple
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                          required
                        >
                          <option value="stamina">Stamina</option>
                          <option value="str">Strength</option>
                          <option value="int">Intelligence</option>
                          <option value="agi">Agility</option>
                        </select>
                        <p class="text-sm text-gray-400">กด Ctrl (หรือ Cmd) ค้างเพื่อเลือกหลายตัวเลือก</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- ปุ่มควบคุม -->
              <div class="flex justify-end gap-3">
                <button
                  type="submit"
                  class="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition duration-200"
                >
                  บันทึก
                </button>
                <button
                  @click="handleDeleteItem"
                  type="button"
                  class="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 transition duration-200"
                >
                  ลบไอเทม
                </button>
                <button
                  @click="$emit('cancelModal')"
                  type="button"
                  class="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 transition duration-200"
                >
                  ยกเลิก
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, computed, watch } from 'vue';
import { projectFirestore } from '@/firebase/config';
export default {
  props: ['item'],
  emits: ['cancelModal', 'itemUpdated', 'itemDeleted'],
  setup(props, { emit }) {
    const activeTab = ref(1);
    const editedItem = ref({
      ...props.item,
      stats: props.item.stats || {
        stamina: 0,
        str: 0,
        int: 0,
        agi: 0,
        luck: 0,
        maxHp: 0,
        atk: 0,
        evasion: 0,
        critical: 0,
        defense: 0
      },
      rarity: props.item.rarity || 0,
      currencyType: props.item.currencyType || 'silver',
      wearable: props.item.wearable || false,
      transfer: props.item.transfer || false,
      upgradable: props.item.upgradable || false,
      decomposable: props.item.decomposable || false,
      decomposeList: props.item.decomposeList ? [...props.item.decomposeList] : [{ itemName: '', chance: 0 }],
      subtype: props.item.subtype || '',
      foodLevel: props.item.foodLevel || 0,
      happinessLevel: props.item.happinessLevel || 0,
      energyLevel: props.item.energyLevel || 0,
      healHpPercentage: props.item.healHpPercentage || 0,
      virusHealPercentage: props.item.virusHealPercentage || 0,
      diceCount: props.item.diceCount || 1,
      damage: props.item.damage || 0,
      durationHours: props.item.durationHours || 0,
      useCount: props.item.useCount || 1,
      fuelLevel: props.item.fuelLevel || 1,
      maxUpgradeCount: props.item.maxUpgradeCount || 0,
      upgradeMaterials: props.item.upgradeMaterials ? [...props.item.upgradeMaterials] : [{ itemName: '', quantity: 0 }],
      upgradeableStats: props.item.upgradeableStats || [],
      explorableMaps: props.item.explorableMaps ? [...props.item.explorableMaps] : [''],
      order: props.item.order || 0,
      disarmRoomCount: props.item.disarmRoomCount || 1,
      maxLoad: props.item.maxLoad || 0,
      waitTimeMinutes: props.item.waitTimeMinutes || 0,
      minLootItems: props.item.minLootItems || 0,
      maxLootItems: props.item.maxLootItems || 0,
      silverReward: props.item.silverReward || 0,
      goldReward: props.item.goldReward || 0,
      diamondReward: props.item.diamondReward || 0,
      compatibleEquipment: props.item.compatibleEquipment || '',
      guardDurationHours: props.item.guardDurationHours || 0,
      fromMap: props.item.fromMap || '',
      minSpirits: props.item.minSpirits || 0,
      maxSpirits: props.item.maxSpirits || 0,
      cooldownHours: props.item.cooldownHours || 0,
      eliminatedRooms: props.item.eliminatedRooms || 0,
      protectCount: props.item.protectCount || 0,
      protectDurationHours: props.item.protectDurationHours || 0,
      minDiamondLoot: props.item.minDiamondLoot || 0,
      maxDiamondLoot: props.item.maxDiamondLoot || 0,
      requiredPreviousSpirits: props.item.requiredPreviousSpirits ? [...props.item.requiredPreviousSpirits] : ['']
    });
    const originalName = ref(props.item.name);
    // Watch type to set wearable for loot type and reset subtype if not spirit
    watch(() => editedItem.value.type, (newType) => {
      if (newType === 'ปล้น') {
        editedItem.value.wearable = true;
      }
      if (newType !== 'วิญญาณ') {
        editedItem.value.subtype = '';
      }
    });
    const totalDecomposeChance = computed(() =>
      editedItem.value.decomposeList.reduce((sum, d) => sum + (d.chance || 0), 0)
    );
    const addDecompose = () => {
      editedItem.value.decomposeList.push({ itemName: '', chance: 0 });
    };
    const removeDecompose = (index) => {
      if (editedItem.value.decomposeList.length > 1) {
        editedItem.value.decomposeList.splice(index, 1);
      }
    };
    const addUpgradeMaterial = () => {
      if (editedItem.value.type === 'หุ่นยนต์สังหาร') {
        editedItem.value.upgradeMaterials.push({ itemName: '', quantity: 0 });
      }
    };
    const removeUpgradeMaterial = (index) => {
      if (editedItem.value.type === 'หุ่นยนต์สังหาร' && editedItem.value.upgradeMaterials.length > 1) {
        editedItem.value.upgradeMaterials.splice(index, 1);
      }
    };
    const addExplorableMap = () => {
      if (editedItem.value.type === 'หุ่นยนต์สังหาร') {
        editedItem.value.explorableMaps.push('');
      }
    };
    const removeExplorableMap = (index) => {
      if (editedItem.value.type === 'หุ่นยนต์สังหาร' && editedItem.value.explorableMaps.length > 1) {
        editedItem.value.explorableMaps.splice(index, 1);
      }
    };
    const addRequiredPreviousSpirit = () => {
      if (editedItem.value.type === 'วิญญาณ') {
        editedItem.value.requiredPreviousSpirits.push('');
      }
    };
    const removeRequiredPreviousSpirit = (index) => {
      if (editedItem.value.type === 'วิญญาณ' && editedItem.value.requiredPreviousSpirits.length > 1) {
        editedItem.value.requiredPreviousSpirits.splice(index, 1);
      }
    };
    const getRarityColors = (rarity) => {
      let effectiveRarity = Number(rarity);
      if (effectiveRarity > 10) {
        effectiveRarity = 10;
      }
      switch (effectiveRarity) {
        case 1: return { bgColor: 'bg-gray-500', textColor: 'text-gray-500', borderColor: 'border-gray-600' };
        case 2: return { bgColor: 'bg-stone-500', textColor: 'text-stone-500', borderColor: 'border-stone-600' };
        case 3: return { bgColor: 'bg-green-500', textColor: 'text-green-500', borderColor: 'border-green-600' };
        case 4: return { bgColor: 'bg-blue-500', textColor: 'text-blue-500', borderColor: 'border-blue-600' };
        case 5: return { bgColor: 'bg-red-500', textColor: 'text-red-500', borderColor: 'border-red-600' };
        case 6: return { bgColor: 'bg-purple-500', textColor: 'text-purple-500', borderColor: 'border-purple-600' };
        case 7: return { bgColor: 'bg-orange-500', textColor: 'text-orange-500', borderColor: 'border-orange-600' };
        case 8: return { bgColor: 'bg-pink-500', textColor: 'text-pink-500', borderColor: 'border-pink-600' };
        case 9: return { bgColor: 'bg-yellow-500', textColor: 'text-yellow-500', borderColor: 'border-yellow-600' };
        case 10: return { bgColor: 'bg-amber-500', textColor: 'text-amber-500', borderColor: 'border-amber-600' };
        default: return { bgColor: 'bg-gray-700', textColor: 'text-gray-500', borderColor: 'border-gray-600' };
      }
    };
    const handleUpdateItem = async () => {
      try {
        if (editedItem.value.decomposable && editedItem.value.decomposeList.every(d => !d.itemName || d.chance <= 0)) {
          alert('กรุณากรอกชื่อไอเทมและโอกาสที่มากกว่า 0 สำหรับการแยกชิ้นส่วนอย่างน้อยหนึ่งรายการ');
          return;
        }
        const rarityColors = getRarityColors(editedItem.value.rarity);
        const decomposeList = editedItem.value.decomposable
          ? editedItem.value.decomposeList.filter(d => d.itemName && d.chance > 0)
          : [];
        const filteredUpgradeMaterials = editedItem.value.type === 'หุ่นยนต์สังหาร'
          ? editedItem.value.upgradeMaterials.filter(m => m.itemName && m.quantity > 0)
          : [];
        const filteredExplorableMaps = editedItem.value.type === 'หุ่นยนต์สังหาร'
          ? editedItem.value.explorableMaps.filter(loc => loc.trim() !== '')
          : [];
        const filteredRequiredPreviousSpirits = editedItem.value.type === 'วิญญาณ'
          ? editedItem.value.requiredPreviousSpirits.filter(spirit => spirit.trim())
          : [];
        const filteredCompatibleEquipment = editedItem.value.type === 'การ์ด'
          ? editedItem.value.compatibleEquipment || null
          : null;
        const updatedGameItemData = {
          name: editedItem.value.name,
          img: editedItem.value.img,
          type: editedItem.value.type,
          subtype: editedItem.value.type === 'วิญญาณ' ? editedItem.value.subtype : null,
          requiredLevel: editedItem.value.requiredLevel,
          weight: editedItem.value.weight,
          wearable: editedItem.value.wearable,
          transfer: editedItem.value.transfer,
          rarity: Number(editedItem.value.rarity),
          currencyType: editedItem.value.currencyType || 'silver',
          rarityColors: rarityColors,
          price: editedItem.value.price,
          description: editedItem.value.description || '',
          upgradable: editedItem.value.upgradable,
          upgradeTo: editedItem.value.upgradable ? editedItem.value.upgradeTo || '' : null,
          upgradeChance: editedItem.value.upgradable ? editedItem.value.upgradeChance || 0 : null,
          decomposable: editedItem.value.decomposable,
          decomposeList: decomposeList,
          stats: editedItem.value.type === 'ปลดกัปดัก' || editedItem.value.type === 'ปล้น' ? null : editedItem.value.stats,
          createdAt: editedItem.value.createdAt || new Date(),
          foodLevel: editedItem.value.type === 'อาหาร' ? editedItem.value.foodLevel : null,
          happinessLevel: editedItem.value.type === 'อาหาร' ? editedItem.value.happinessLevel : null,
          energyLevel: editedItem.value.type === 'อาหาร' ? editedItem.value.energyLevel : null,
          healHpPercentage: editedItem.value.type === 'รักษา' ? editedItem.value.healHpPercentage : null,
          virusHealPercentage: editedItem.value.type === 'รักษา' ? editedItem.value.virusHealPercentage : null,
          diceCount: editedItem.value.type === 'กัปดัก' ? editedItem.value.diceCount : null,
          damage: ['กัปดัก', 'ระเบิด'].includes(editedItem.value.type) ? editedItem.value.damage : null,
          durationHours: editedItem.value.type === 'กัปดัก' ? editedItem.value.durationHours : null,
          useCount: editedItem.value.type === 'กัปดัก' ? editedItem.value.useCount : null,
          fuelLevel: editedItem.value.type === 'พาหนะ' ? editedItem.value.fuelLevel : null,
          maxUpgradeCount: editedItem.value.type === 'หุ่นยนต์สังหาร' ? editedItem.value.maxUpgradeCount : null,
          upgradeMaterials: filteredUpgradeMaterials,
          upgradeableStats: editedItem.value.type === 'อวัยวะจักรกล' ? editedItem.value.upgradeableStats : [],
          explorableMaps: filteredExplorableMaps,
          order: editedItem.value.type === 'หนังสือ' ? editedItem.value.order : null,
          disarmRoomCount: editedItem.value.type === 'ปลดกัปดัก' ? editedItem.value.disarmRoomCount : null,
          maxLoad: editedItem.value.type === 'หุ่นยนต์สังหาร' ? editedItem.value.maxLoad : null,
          waitTimeMinutes: editedItem.value.type === 'ปล้น' ? editedItem.value.waitTimeMinutes : null,
          minLootItems: editedItem.value.type === 'ปล้น' ? editedItem.value.minLootItems : null,
          maxLootItems: editedItem.value.type === 'ปล้น' ? editedItem.value.maxLootItems : null,
          silverReward: editedItem.value.type === 'ปล้น' ? editedItem.value.silverReward : null,
          goldReward: editedItem.value.type === 'ปล้น' ? editedItem.value.goldReward : null,
          diamondReward: editedItem.value.type === 'ปล้น' ? editedItem.value.diamondReward : null,
          compatibleEquipment: filteredCompatibleEquipment,
          requiredPreviousSpirits: filteredRequiredPreviousSpirits,
          guardDurationHours: editedItem.value.type === 'วิญญาณ' && editedItem.value.subtype === 'วิญญาณเฝ้าห้อง' ? editedItem.value.guardDurationHours : null,
          fromMap: editedItem.value.type === 'วิญญาณ' && editedItem.value.subtype === 'วิญญาณเฝ้าห้อง' ? editedItem.value.fromMap : null,
          minSpirits: editedItem.value.type === 'วิญญาณ' && editedItem.value.subtype === 'วิญญาณเฝ้าห้อง' ? editedItem.value.minSpirits : null,
          maxSpirits: editedItem.value.type === 'วิญญาณ' && editedItem.value.subtype === 'วิญญาณเฝ้าห้อง' ? editedItem.value.maxSpirits : null,
          cooldownHours: editedItem.value.type === 'วิญญาณ' && ['วิญญาณเฝ้าห้อง', 'วิญญาณผู้พิทักษ์', 'วิญญาณดูดทรัพย์'].includes(editedItem.value.subtype) ? editedItem.value.cooldownHours : null,
          eliminatedRooms: editedItem.value.type === 'วิญญาณ' && editedItem.value.subtype === 'วิญญาณค้นหาผู้เล่น' ? editedItem.value.eliminatedRooms : null,
          protectCount: editedItem.value.type === 'วิญญาณ' && editedItem.value.subtype === 'วิญญาณผู้พิทักษ์' ? editedItem.value.protectCount : null,
          protectDurationHours: editedItem.value.type === 'วิญญาณ' && editedItem.value.subtype === 'วิญญาณผู้พิทักษ์' ? editedItem.value.protectDurationHours : null,
          minDiamondLoot: editedItem.value.type === 'วิญญาณ' && editedItem.value.subtype === 'วิญญาณดูดทรัพย์' ? editedItem.value.minDiamondLoot : null,
          maxDiamondLoot: editedItem.value.type === 'วิญญาณ' && editedItem.value.subtype === 'วิญญาณดูดทรัพย์' ? editedItem.value.maxDiamondLoot : null
        };
        const oldGameItemId = originalName.value;
        const newGameItemId = editedItem.value.name.trim();
        if (!newGameItemId || /[/\.#$$$ $$]/.test(newGameItemId)) {
          alert('ชื่อไอเทมไม่ถูกต้อง ห้ามใช้ / . # $ [ ] หรือปล่อยว่าง');
          return;
        }
        // Start a Firestore batch for atomic updates
        const batch = projectFirestore.batch();
        // Update gameItems
        if (oldGameItemId !== newGameItemId) {
          batch.delete(projectFirestore.collection('gameItems').doc(oldGameItemId));
          batch.set(projectFirestore.collection('gameItems').doc(newGameItemId), updatedGameItemData);
        } else {
          batch.set(projectFirestore.collection('gameItems').doc(oldGameItemId), updatedGameItemData);
        }
        // Update items collection where name matches
        const itemsSnapshot = await projectFirestore.collection('items')
          .where('name', '==', oldGameItemId)
          .get();
        itemsSnapshot.forEach(doc => {
          batch.update(doc.ref, {
            name: newGameItemId,
            stats: updatedGameItemData.stats,
            type: updatedGameItemData.type,
            subtype: updatedGameItemData.subtype,
            requiredLevel: updatedGameItemData.requiredLevel,
            weight: updatedGameItemData.weight,
            currencyType: updatedGameItemData.currencyType
          });
        });
        // Update characterPrivate for characters equipping this item via itemNames
        const charPrivateSnapshot = await projectFirestore.collection('characterPrivate')
          .where('itemNames', 'array-contains', oldGameItemId)
          .get();
        for (const doc of charPrivateSnapshot.docs) {
          const charData = doc.data();
          const itemNames = charData.itemNames || [];
          const itemReferences = charData.itemReferences || [];
          const itemStats = charData.itemStats || {
            stamina: 0, str: 0, int: 0, agi: 0, luck: 0, maxHp: 0, atk: 0, evasion: 0, critical: 0, defense: 0
          };
          const stats = charData.stats || { stamina: 0 };
          const bonusStats = charData.bonusStats || { stamina: 0, maxHp: 0 };
          const traitStats = charData.traitStats || { stamina: 0 };
          const skillStats = charData.skillStats || { stamina: 0 };
          const titleStats = charData.titleStats || { stamina: 0 };
          const tattooStats = charData.tattooStats || { stamina: 0 };
          const ghostStats = charData.ghostStats || { stamina: 0, maxHp: 0 };
          const damageTaken = charData.damageTaken || 0;
          const itemIndex = itemNames.indexOf(oldGameItemId);
          if (itemIndex === -1) {
            console.warn(`Item ${oldGameItemId} not found in itemNames for character ${doc.id}`);
            continue;
          }
          const itemId = itemReferences[itemIndex];
          if (!itemId) {
            console.warn(`No item reference at index ${itemIndex} for character ${doc.id}`);
            continue;
          }
          const itemDoc = await projectFirestore.collection('items').doc(itemId).get();
          if (!itemDoc.exists) {
            console.warn(`Item ${itemId} not found for character ${doc.id}`);
            continue;
          }
          const oldItemData = itemDoc.data();
          const oldItemStats = oldItemData.stats || {
            stamina: 0, str: 0, int: 0, agi: 0, luck: 0, maxHp: 0, atk: 0, evasion: 0, critical: 0, defense: 0
          };
          const oldStaminaSum =
            (itemStats.stamina || 0) +
            (bonusStats.stamina || 0) +
            (stats.stamina || 0) +
            (traitStats.stamina || 0) +
            (skillStats.stamina || 0) +
            (titleStats.stamina || 0) +
            (tattooStats.stamina || 0) +
            (ghostStats.stamina || 0);
          const oldMaxHp = (oldStaminaSum * 20) + (itemStats.maxHp || 0) + (bonusStats.maxHp || 0) + (stats.maxHp || 0) + (traitStats.maxHp || 0) + (skillStats.maxHp || 0) + (titleStats.maxHp || 0) + (tattooStats.maxHp || 0) + (ghostStats.maxHp || 0);
          const tempItemStats = {
            stamina: (itemStats.stamina || 0) - (oldItemStats.stamina || 0),
            str: (itemStats.str || 0) - (oldItemStats.str || 0),
            int: (itemStats.int || 0) - (oldItemStats.int || 0),
            agi: (itemStats.agi || 0) - (oldItemStats.agi || 0),
            luck: (itemStats.luck || 0) - (oldItemStats.luck || 0),
            maxHp: (itemStats.maxHp || 0) - (oldItemStats.maxHp || 0),
            atk: (itemStats.atk || 0) - (oldItemStats.atk || 0),
            evasion: (itemStats.evasion || 0) - (oldItemStats.evasion || 0),
            critical: (itemStats.critical || 0) - (oldItemStats.critical || 0),
            defense: (itemStats.defense || 0) - (oldItemStats.defense || 0)
          };
          const newItemStats = {
            stamina: (tempItemStats.stamina || 0) + (updatedGameItemData.stats?.stamina || 0),
            str: (tempItemStats.str || 0) + (updatedGameItemData.stats?.str || 0),
            int: (tempItemStats.int || 0) + (updatedGameItemData.stats?.int || 0),
            agi: (tempItemStats.agi || 0) + (updatedGameItemData.stats?.agi || 0),
            luck: (tempItemStats.luck || 0) + (updatedGameItemData.stats?.luck || 0),
            maxHp: (tempItemStats.maxHp || 0) + (updatedGameItemData.stats?.maxHp || 0),
            atk: (tempItemStats.atk || 0) + (updatedGameItemData.stats?.atk || 0),
            evasion: (tempItemStats.evasion || 0) + (updatedGameItemData.stats?.evasion || 0),
            critical: (tempItemStats.critical || 0) + (updatedGameItemData.stats?.critical || 0),
            defense: (tempItemStats.defense || 0) + (updatedGameItemData.stats?.defense || 0)
          };
          const newStaminaSum =
            (newItemStats.stamina || 0) +
            (bonusStats.stamina || 0) +
            (stats.stamina || 0) +
            (traitStats.stamina || 0) +
            (skillStats.stamina || 0) +
            (titleStats.stamina || 0) +
            (tattooStats.stamina || 0) +
            (ghostStats.stamina || 0);
          const newMaxHp = (newStaminaSum * 20) + (newItemStats.maxHp || 0) + (bonusStats.maxHp || 0) + (stats.maxHp || 0) + (traitStats.maxHp || 0) + (skillStats.maxHp || 0) + (titleStats.maxHp || 0) + (tattooStats.maxHp || 0) + (ghostStats.maxHp || 0);
          const currentHP = oldMaxHp - damageTaken;
          const hpPercentage = oldMaxHp > 0 ? currentHP / oldMaxHp : 0;
          const newHP = Math.round(newMaxHp * hpPercentage);
          const newDamageTaken = Math.max(0, newMaxHp - newHP);
          console.log(`Updating character ${doc.id}:`, {
            oldItemStats,
            newItemStats,
            oldMaxHp,
            newMaxHp,
            currentHP,
            newHP,
            newDamageTaken
          });
          batch.update(doc.ref, {
            itemNames: itemNames,
            itemStats: newItemStats,
            damageTaken: newDamageTaken
          });
        }
        // Update characterPrivate for characters equipping this item via mechanicalNames
        const mechCharPrivateSnapshot = await projectFirestore.collection('characterPrivate')
          .where('mechanicalNames', 'array-contains', oldGameItemId)
          .get();
        for (const doc of mechCharPrivateSnapshot.docs) {
          const charData = doc.data();
          const mechanicalNames = charData.mechanicalNames || [];
          const mechanicalItemIds = charData.mechanicalItemIds || [];
          const itemStats = charData.itemStats || {
            stamina: 0, str: 0, int: 0, agi: 0, luck: 0, maxHp: 0, atk: 0, evasion: 0, critical: 0, defense: 0
          };
          const stats = charData.stats || { stamina: 0 };
          const bonusStats = charData.bonusStats || { stamina: 0, maxHp: 0 };
          const traitStats = charData.traitStats || { stamina: 0 };
          const skillStats = charData.skillStats || { stamina: 0 };
          const titleStats = charData.titleStats || { stamina: 0 };
          const tattooStats = charData.tattooStats || { stamina: 0 };
          const ghostStats = charData.ghostStats || { stamina: 0, maxHp: 0 };
          const damageTaken = charData.damageTaken || 0;
          const itemIndex = mechanicalNames.indexOf(oldGameItemId);
          if (itemIndex === -1) {
            console.warn(`Item ${oldGameItemId} not found in mechanicalNames for character ${doc.id}`);
            continue;
          }
          const itemId = mechanicalItemIds[itemIndex];
          if (!itemId) {
            console.warn(`No item reference at index ${itemIndex} for character ${doc.id}`);
            continue;
          }
          const itemDoc = await projectFirestore.collection('items').doc(itemId).get();
          if (!itemDoc.exists) {
            console.warn(`Item ${itemId} not found for character ${doc.id}`);
            continue;
          }
          const oldItemData = itemDoc.data();
          const oldBaseStats = oldItemData.stats || {
            stamina: 0, str: 0, int: 0, agi: 0, luck: 0, maxHp: 0, atk: 0, evasion: 0, critical: 0, defense: 0
          };
          const oldUpgradeStats = oldItemData.upgradeStats || {
            stamina: 0, str: 0, int: 0, agi: 0, luck: 0, maxHp: 0, atk: 0, evasion: 0, critical: 0, defense: 0
          };
          const oldEffectiveStats = {
            stamina: (oldBaseStats.stamina || 0) + (oldUpgradeStats.stamina || 0),
            str: (oldBaseStats.str || 0) + (oldUpgradeStats.str || 0),
            int: (oldBaseStats.int || 0) + (oldUpgradeStats.int || 0),
            agi: (oldBaseStats.agi || 0) + (oldUpgradeStats.agi || 0),
            luck: (oldBaseStats.luck || 0) + (oldUpgradeStats.luck || 0),
            maxHp: (oldBaseStats.maxHp || 0) + (oldUpgradeStats.maxHp || 0),
            atk: (oldBaseStats.atk || 0) + (oldUpgradeStats.atk || 0),
            evasion: (oldBaseStats.evasion || 0) + (oldUpgradeStats.evasion || 0),
            critical: (oldBaseStats.critical || 0) + (oldUpgradeStats.critical || 0),
            defense: (oldBaseStats.defense || 0) + (oldUpgradeStats.defense || 0)
          };
          if (oldGameItemId !== newGameItemId) {
            mechanicalNames[itemIndex] = newGameItemId;
          }
          const oldStaminaSum =
            (itemStats.stamina || 0) +
            (bonusStats.stamina || 0) +
            (stats.stamina || 0) +
            (traitStats.stamina || 0) +
            (skillStats.stamina || 0) +
            (titleStats.stamina || 0) +
            (tattooStats.stamina || 0) +
            (ghostStats.stamina || 0);
          const oldMaxHp = (oldStaminaSum * 20) + (itemStats.maxHp || 0) + (bonusStats.maxHp || 0) + (stats.maxHp || 0) + (traitStats.maxHp || 0) + (skillStats.maxHp || 0) + (titleStats.maxHp || 0) + (tattooStats.maxHp || 0) + (ghostStats.maxHp || 0);
          const tempItemStats = {
            stamina: (itemStats.stamina || 0) - oldEffectiveStats.stamina,
            str: (itemStats.str || 0) - oldEffectiveStats.str,
            int: (itemStats.int || 0) - oldEffectiveStats.int,
            agi: (itemStats.agi || 0) - oldEffectiveStats.agi,
            luck: (itemStats.luck || 0) - oldEffectiveStats.luck,
            maxHp: (itemStats.maxHp || 0) - oldEffectiveStats.maxHp,
            atk: (itemStats.atk || 0) - oldEffectiveStats.atk,
            evasion: (itemStats.evasion || 0) - oldEffectiveStats.evasion,
            critical: (itemStats.critical || 0) - oldEffectiveStats.critical,
            defense: (itemStats.defense || 0) - oldEffectiveStats.defense
          };
          const newEffectiveStats = {
            stamina: (updatedGameItemData.stats?.stamina || 0) + (oldUpgradeStats.stamina || 0),
            str: (updatedGameItemData.stats?.str || 0) + (oldUpgradeStats.str || 0),
            int: (updatedGameItemData.stats?.int || 0) + (oldUpgradeStats.int || 0),
            agi: (updatedGameItemData.stats?.agi || 0) + (oldUpgradeStats.agi || 0),
            luck: (updatedGameItemData.stats?.luck || 0) + (oldUpgradeStats.luck || 0),
            maxHp: (updatedGameItemData.stats?.maxHp || 0) + (oldUpgradeStats.maxHp || 0),
            atk: (updatedGameItemData.stats?.atk || 0) + (oldUpgradeStats.atk || 0),
            evasion: (updatedGameItemData.stats?.evasion || 0) + (oldUpgradeStats.evasion || 0),
            critical: (updatedGameItemData.stats?.critical || 0) + (oldUpgradeStats.critical || 0),
            defense: (updatedGameItemData.stats?.defense || 0) + (oldUpgradeStats.defense || 0)
          };
          const newItemStats = {
            stamina: (tempItemStats.stamina || 0) + newEffectiveStats.stamina,
            str: (tempItemStats.str || 0) + newEffectiveStats.str,
            int: (tempItemStats.int || 0) + newEffectiveStats.int,
            agi: (tempItemStats.agi || 0) + newEffectiveStats.agi,
            luck: (tempItemStats.luck || 0) + newEffectiveStats.luck,
            maxHp: (tempItemStats.maxHp || 0) + newEffectiveStats.maxHp,
            atk: (tempItemStats.atk || 0) + newEffectiveStats.atk,
            evasion: (tempItemStats.evasion || 0) + newEffectiveStats.evasion,
            critical: (tempItemStats.critical || 0) + newEffectiveStats.critical,
            defense: (tempItemStats.defense || 0) + newEffectiveStats.defense
          };
          const newStaminaSum =
            (newItemStats.stamina || 0) +
            (bonusStats.stamina || 0) +
            (stats.stamina || 0) +
            (traitStats.stamina || 0) +
            (skillStats.stamina || 0) +
            (titleStats.stamina || 0) +
            (tattooStats.stamina || 0) +
            (ghostStats.stamina || 0);
          const newMaxHp = (newStaminaSum * 20) + (newItemStats.maxHp || 0) + (bonusStats.maxHp || 0) + (stats.maxHp || 0) + (traitStats.maxHp || 0) + (skillStats.maxHp || 0) + (titleStats.maxHp || 0) + (tattooStats.maxHp || 0) + (ghostStats.maxHp || 0);
          const currentHP = oldMaxHp - damageTaken;
          const hpPercentage = oldMaxHp > 0 ? currentHP / oldMaxHp : 0;
          const newHP = Math.round(newMaxHp * hpPercentage);
          const newDamageTaken = Math.max(0, newMaxHp - newHP);
          console.log(`Updating character ${doc.id} for mechanical item:`, {
            oldEffectiveStats,
            newEffectiveStats,
            oldMaxHp,
            newMaxHp,
            currentHP,
            newHP,
            newDamageTaken
          });
          batch.update(doc.ref, {
            mechanicalNames: mechanicalNames,
            itemStats: newItemStats,
            damageTaken: newDamageTaken
          });
        }
        // Commit the batch
        await batch.commit();
        console.log('Item and related data updated successfully:', newGameItemId);
        emit('itemUpdated', updatedGameItemData);
        emit('cancelModal');
      } catch (error) {
        console.error('Error updating item:', error);
        alert(`เกิดข้อผิดพลาด: ${error.message}`);
      }
    };
    const handleDeleteItem = async () => {
      if (confirm('คุณแน่ใจหรือไม่ว่าต้องการลบไอเทมนี้? การกระทำนี้ไม่สามารถย้อนกลับได้')) {
        try {
          await projectFirestore.collection('gameItems').doc(originalName.value).delete();
          emit('itemDeleted');
          emit('cancelModal');
        } catch (error) {
          console.error('Error deleting item:', error);
          alert('เกิดข้อผิดพลาดในการลบไอเทม');
        }
      }
    };
    return {
      activeTab,
      editedItem,
      totalDecomposeChance,
      addDecompose,
      removeDecompose,
      addUpgradeMaterial,
      removeUpgradeMaterial,
      addExplorableMap,
      removeExplorableMap,
      addRequiredPreviousSpirit,
      removeRequiredPreviousSpirit,
      handleUpdateItem,
      handleDeleteItem
    };
  }
};
</script>
<style scoped>
.animate-fade-in {
  animation: fadeIn 0.5s ease-in;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
